export var DEPLOY_DATE = new Date('2026-04-30T15:53:25+0000');
